import { UPDATE_SCHEDULE_REMINDER } from 'apollo/mutations/schedule-reminder-mutations';
import { useApolloUpdate } from 'hooks';
import { ScheduleReminderUpdateInput, UpdateScheduleReminderMutationResult } from '__generated__/graphql';

export default function useScheduleReminderUpdate() {
  return useApolloUpdate<ScheduleReminderUpdateInput, UpdateScheduleReminderMutationResult['data']>(
    UPDATE_SCHEDULE_REMINDER,
    'reminder'
  );
}
